import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import type { IonInput } from "@ionic/angular";

@Component({
	selector: "app-input-positive-number",
	templateUrl: "./input-positive-numbers.component.html",
	styleUrls: ["./input-positive-numbers.component.scss"],
})
export class InputPositiveNumberComponent implements OnInit {
	@ViewChild("ionInputEl", { static: true }) ionInputEl!: IonInput;

	@Input() ariaLabel = "";
	@Input() minimumValue = 0;
	@Input() maximumValue;
	@Input() initialValue: number;
	@Input() disabled = false;
	@Input() step = "any";
	@Input() id = "";
	@Input() input: number = null;
	@Output() valueChange = new EventEmitter<number>();

	ngOnInit(): void {
		const isValidInitialValue =
			this.initialValue >= this.minimumValue &&
			// Only check maximumValue if it is defined
			// This will allow maximumValue to be undefined
			// or null as we do not use maximumValue everywhere
			(this.maximumValue == null ||
				this.initialValue <= this.maximumValue);

		this.input = isValidInitialValue
			? this.initialValue
			: this.minimumValue;
	}

	handleInput(ev: Event) {
		const value = this.getValue((ev.target! as HTMLInputElement).value);

		this.ionInputEl.value = value;
		this.input = value;
		this.valueChange.emit(value);
	}

	getValue(value: string): number {
		return Number(value);
	}
}
